import gql from "graphql-tag"

const GRAPHQL_DATE_FORMAT = "YYYY-MM-DD"

const ASSET_ALERT_INFO_FRAGMENT = gql`
  fragment AssetAlertInfo on AssetAlert {
    id
    rentalPolicy
    devices {
      name
      assets {
        id
        imageId
      }
    }
    ownedBy {
      id
      name
    }
    locations {
      id
      name
    }
    subscriptions {
      id
      user {
        id
        name
      }
      email
      sms
    }
  }
`

export { GRAPHQL_DATE_FORMAT, ASSET_ALERT_INFO_FRAGMENT }
